// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React from 'react';
import styled from 'styled-components';

const S = {
  SearchBar: styled.div`
    display: flex;
  `,
  SearchInputContainer: styled.div`
  `,
  SearchInput: styled.input`
    border-bottom: 1px solid #D6D6D6;
    line-height: 25px;
    border-radius: 0px 4px 4px 0px;
    padding: 0px 5px;
  `,
}

interface searchProps {
  searchType: string;
  handleSearch: (value: string) => void;
}

const SearchBar = (props: searchProps): JSX.Element => {
  const handleSearch = props.handleSearch;
  const searchType = props.searchType;
  const search = (value: string) => {
    handleSearch(value)
  }

  return (
    <S.SearchBar>
      <S.SearchInput placeholder={`Search ${searchType}`} onChange={(e: any) => { search(e.target.value) }}/>
    </S.SearchBar>
  )

}

export default SearchBar;
